/**
 * Hands the session's locale (GET /api/auth/capabilities: the institution's
 * languages and country, the person's language) to I18nProvider, and the
 * platform's back when the session ends. Renders nothing.
 */

import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { usePermissions } from '../context/PermissionContext';
import { useI18n } from './I18nProvider';

export function LocaleSync() {
  const { isAuthenticated } = useAuth();
  const { locale } = usePermissions();
  const { applyServerLocale, resetToPlatform, forgetPick } = useI18n();
  const wasSignedIn = useRef(isAuthenticated);

  useEffect(() => {
    if (isAuthenticated && locale) applyServerLocale(locale);
  }, [isAuthenticated, locale, applyServerLocale]);

  useEffect(() => {
    if (!isAuthenticated) resetToPlatform();
  }, [isAuthenticated, resetToPlatform]);

  // Only a real sign-out forgets the language picked on this visit; the
  // sign-in screen's own pick has to survive into the session it opens.
  useEffect(() => {
    if (wasSignedIn.current && !isAuthenticated) forgetPick();
    wasSignedIn.current = isAuthenticated;
  }, [isAuthenticated, forgetPick]);

  return null;
}

export default LocaleSync;
